
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class RewardsMasterGrid extends Serenity.EntityGrid<RewardsMasterRow, any> {
        protected getColumnsKey() { return 'OMS.RewardsMaster'; }
        protected getDialogType() { return RewardsMasterDialog; }
        protected getIdProperty() { return RewardsMasterRow.idProperty; }
        protected getInsertPermission() { return RewardsMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return RewardsMasterRow.localTextPrefix; }
        protected getService() { return RewardsMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}